'use strict';

require('./navigation-bar.scss');

module.exports = {
  template: require('./navigation-bar.html'),
  controller: require('./navigation-bar.controller'),
  controllerAs: 'vm'
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/navigation-bar/index.js
 ** module id = 48
 ** module chunks = 0
 **/